/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { UserFeatureCode, UserPreferencesResponse } from '@g17eco/types/user';

export const hasUserFeatureFlag = (preferences: UserPreferencesResponse, featureCode: UserFeatureCode) => {
  if ('featureFlags' in preferences) {
    return preferences.featureFlags.some((flag) => flag.code === featureCode);
  }
  return false;
}
